import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GiftCardPill from 'components/giftcard/giftCardPill';
import { Text } from 'components/core/Typography';

import './unitDescription.scss';


export default function UnitDescription({
	className,
	unitSize,
	unitType,
	amenitiesText,
	promotion,
	vehicleAccommodation,
	tierName,
	tierDescription,
	giftCardOffer,
}) {
	const showAmenitiesText = amenitiesText || tierDescription;

	return (
		<div className={classnames('unit-description', className)}>
			<Text
				className="unit-size-label-description"
				size="small"
			>
				{unitSize} <span className="unit-type">{unitType}</span>{' '}
				{!!tierName && <span> - {tierName}</span>}
				{giftCardOffer?.isGiftCardEligible && (
					<GiftCardPill giftCardValue={giftCardOffer?.giftCardValue} />
				)}
			</Text>
			{!!vehicleAccommodation && (
				<Text
					size="tiny"
					className="vehicle-accommodation"
				>
					{vehicleAccommodation}
				</Text>
				
			)}
			{showAmenitiesText && (
				<Text
					className="unit-amenities"
					last={!promotion}
				>
					{amenitiesText && tierDescription ? (
						<>
							{`${amenitiesText}, `}
							<span>{tierDescription}</span>
						</>
					) : (
						<span>{amenitiesText || tierDescription}</span>
					)}
				</Text>
			)}

			{!!promotion && (
				<Text
					color="green"
					className="unit-promotion"
					last
				>
					{promotion}
				</Text>
			)}
		</div>
	);
}

UnitDescription.propTypes = {
	className: PropTypes.string,
	unitSize: PropTypes.string.isRequired,
	unitType: PropTypes.string.isRequired,
	promotion: PropTypes.node,
	amenitiesText: PropTypes.string,
	vehicleAccommodation: PropTypes.string,
	tierName: PropTypes.string,
	tierDescription: PropTypes.string,
	giftCardOffer: PropTypes.object
};
